export default class {
    constructor (lodash, COURSE_TRAINING_TYPE_ENUM) {
        this.lodash = lodash;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
    }

    isOnlineTrainingDeadlineChanged (oldTrainings, trainings) {
        const oldOnlineTrainings = this.lodash.filter(oldTrainings, training => training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE);
        const oldDeadlines = this.lodash.map(oldOnlineTrainings, 'deadline');

        const onlineTrainings = this.lodash.filter(trainings, training => training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE);
        const deadlines = this.lodash.map(onlineTrainings, 'deadline');
        return !this.lodash.isEqual(oldDeadlines, deadlines);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/occurrence/training/index.js